import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  Input,
  HostListener,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { from, iif, Observable } from "rxjs";
import { map, filter, switchMap, finalize } from "rxjs/operators";
import { StudentService } from "src/app/services/student.service";
import { Student } from "src/app/models/student";
import { Career } from "src/app/interface/career";
import {
  AngularFireStorage,
  AngularFireUploadTask,
} from "@angular/fire/storage";
import { ConfigService } from "src/app/services/config.service";
import * as moment from "moment";
import { layer } from "@fortawesome/fontawesome-svg-core";
import { ViewportScroller } from "@angular/common";
import { MailService } from "src/app/services/mail.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  @ViewChild("allForm") allForm: ElementRef;
  public stateDocument: string;
  public randomNumer: any;
  title = "matriculaUCN";
  studentForm: FormGroup;

  public payDetail: any;
  public patronCedula: "[0-9]{3}[-][0-9]{6}[-][0-9]{4}[A-Z]{1}";
  public isCedula: boolean;
  ///efecto de paralaje para las imagenes
  public ww: any;
  public wh: any;
  public mouseY: any;
  public mouseX: any;
  public transX: any;
  public transY: any;
  public text_effect: any;
  public innerHeight: any;
  public Age: number;
  txtName: string;
  txtLastname: string;
  @Input() ngStyle: { [klass: string]: any };
  ////datos para estudiantes
  uploadPercent: Observable<number>;
  urlImage: Observable<string>;
  urlDiploma: string;
  urlDiplomaName: string;
  urlCertificate: string;
  urlCertificateName: string;
  urlIdentiCard1: string;
  urlIdentiCard1Name: string;
  urlIdentiCard2: string;
  urlIdentiCard2Name: string;
  urlPhoto: string;
  urlPhotoName: string;
  imgDiploma: string;
  imgCertificate: string;
  imgIdentiCard1: string;
  imgIdentiCard2: string;
  imgPhoto: string;
  country: any = [];
  careerObjects: Career[];
  careerSelected: Career;
  turnAvailable: any = [
    {
      name: "Regular",
    },
    {
      name: "Sabatina",
    },
    {
      name: "Dominical",
    },
  ];
  @Input() isRegular: boolean;
  @Input() isSabbatine: boolean;
  @Input() isDominical: boolean;
  step1 = false;
  campusSelected: string;
  welcomeValidation: FormGroup;
  stepValidation1: FormGroup;
  stepValidation2: FormGroup;
  stepValidation3: FormGroup;
  campusSelectedList: Career[];
  docType: string = "*";
  gen: string;
  civil_status: string;
  list: any = [
    {
      name: "Cédula",
    },
    {
      name: "Partida de Nacimiento",
    },
    {
      name: "Cédula de Residencia",
    },
    {
      name: "Pasaporte",
    },
  ];
  civilStatuslist: any = [
    {
      name: "Soltero",
    },
    {
      name: "Casado",
    },
    {
      name: "Viudo",
    },
    {
      name: "Separado",
    },
    {
      name: "Unión libre",
    },
  ];

  countryList: any = [
    {
      name: "Nicaragua",
      state: [
        "Managua",
        "Rivas",
        "Granada",
        "Masaya",
        "León",
        "Chinandega",
        "Carazo",
        "Nueva Segovia",
        "Madriz",
        "Estelí",
        "Jinotega",
        "Matagalpa",
        "Boaco",
        "Chontales",
        "Río San Juan",
        "Atlántico Norte",
        "Atlántico Sur",
      ],
    },
    {
      name: "Costa Rica",
      state: [
        "San José",
        "Alajuela",
        "Cartago",
        "Heredia",
        "Guanacaste",
        "Puntarenas",
        "Limón",
      ],
    },
    {
      name: "Estados Unidos",
      state: [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Hawái",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Luisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "Nueva Jersey",
        "Nuevo México",
        "Nueva York",
        "Carolina del Norte",
        "Dakota del Norte",
        "Ohio",
        "Oklahoma",
        "Oregón",
        "Pensilvania",
        "Rhode Island",
        "Carolina del Sur",
        "Dakota del Sur",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "Virginia Occidental",
        "Wisconsin",
        "Wyoming",
      ],
    },
    {
      name: "Canadá",
      state: [
        "Ontario",
        "Quebec",
        "Nueva Escocia",
        "Nuevo Brunswick",
        "Manitoba",
        "Territorios del Noroeste",
        "Columbia Británica",
        "Isla del Príncipe Eduardo",
        "Yukón",
        "Saskatchewan",
        "Alberta",
        "Terranova y Labrador",
        "Nunavut",
      ],
    },
    {
      name: "Guatemala",
      state: [
        "Alta Verapaz",
        "Baja Verapaz",
        "Chimaltenango",
        "Chiquimula",
        "El Progreso",
        "Escuintla",
        "Guatemala",
        "Huehuetenango",
        "Izabal",
        "Jalapa",
        "Jutiapa",
        "Petén",
        "Quetzaltenango",
        "Quiché",
        "Retalhuleu",
        "Sacatepéquez",
        "San Marcos",
        "Santa Rosa",
        "Sololá",
        "Suchitepéquez",
        "Totonicapán",
        "Zacapa",
      ],
    },
    {
      name: "Panamá",
      state: [
        "Bocas del Toro",
        "Coclé",
        "Colón",
        "Chiriquí",
        "Darién",
        "Herrera",
        "Los Santos",
        "Panamá",
        "Veraguas",
        "Panamá Oeste",
      ],
    },
    {
      name: "México",
      state: [
        "Aguascalientes",
        "Baja California",
        "Baja California Sur",
        "Campeche",
        "Coahuila",
        "Colima",
        "Chiapas",
        "Chihuahua",
        "Distrito Federal",
        "Durango",
        "Guanajuato",
        "Guerrero",
        "Hidalgo",
        "Jalisco",
        "México",
        "Michoacán",
        "Morelos",
        "Nayarit",
        "Nuevo León",
        "Oaxaca",
        "Puebla",
        "Querétaro",
        "Quintana Roo",
        "San Luis Potosí",
        "Sinaloa",
        "Sonora",
        "Tabasco",
        "Tamaulipas",
        "Tlaxcala",
        "Veracruz",
        "Yucatán",
        "Zacatecas",
      ],
    },
    {
      name: "El Salvador",
      state: [
        "Ahuachapán",
        "Cabañas",
        "Chalatenango",
        "Cuscatlán",
        "La Libertad",
        "La Paz",
        "La Unión",
        "Morazán",
        "San Miguel",
        "San Salvador",
        "San Vicente",
        "Santa Ana",
        "Sonsonate",
        "Usulután",
      ],
    },
    {
      name: "Honduras",
      state: [
        "Atlántida",
        "Choluteca",
        "Colón",
        "Comayagua",
        "Copán",
        "Cortes",
        "El Paraíso",
        "Francisco Morazán",
        "Gracias a Dios",
        "Intibucá",
        "Islas de la Bahía",
        "La Paz",
        "Lempira",
        "Ocotepeque",
        "Olancho",
        "Santa Bárbara",
        "Valle",
        "Yoro",
      ],
    },
    {
      name: "Argentina",
      state: [
        "Buenos Aires",
        "Catamarca",
        "Chaco",
        "Chubut",
        "Córdoba",
        "Corrientes",
        "Entre Ríos",
        "Formosa",
        "Jujuy",
        "La Pampa",
        "La Rioja",
        "Mendoza",
        "Misiones",
        "Neuquén",
        "Río Negro",
        "Salta",
        "San Juan",
        "San Luis",
        "Santa Cruz",
        "Santa Fe",
        "Santiago del Estero",
        "Tierra del Fuego",
        "Tucumán",
      ],
    },
    {
      name: "Venezuela",
      state: [
        "Amazonas",
        "Anzoátegui",
        "Apure",
        "Aragua",
        "Barinas",
        "Bolívar",
        "Carabobo",
        "Cojedes",
        "Delta Amacuro",
        "Distrito Capital",
        "Falcón",
        "Guárico",
        "Lara",
        "Mérida",
        "Miranda",
        "Monagas",
        "Nueva Esparta",
        "Portuguesa",
        "Sucre",
        "Táchira",
        "Trujillo",
        "Vargas",
        "Yaracuy",
        "Zulia",
      ],
    },
    {
      name: "Colombia",
      state: [
        "Amazonas",
        "Antioquia",
        "Arauca",
        "Atlántico",
        "Bolívar",
        "Boyacá",
        "Caldas",
        "Caquetá",
        "Casanare",
        "Cauca",
        "Cesar",
        "Chocó",
        "Córdoba",
        "Cundinamarca",
        "Guainía",
        "Guaviare",
        "Huila",
        "La Guajira",
        "Magdalena",
        "Meta",
        "Nariño",
        "Norte de Santander",
        "Putumayo",
        "Quindío",
        "Risaralda",
        "San Andrés y Providencia",
        "Santander",
        "Sucre",
        "Tolima",
        "Valle del Cauca",
        "Vaupés",
        "Vichada",
      ],
    },
    {
      name: "Chile",
      state: [
        "Arica y Parinacota",
        "Tarapacá",
        "Antofagasta",
        "Atacama",
        "Coquimbo",
        "Valparaíso",
        "Metropolitana",
        "O'Higgins",
        "Maule",
        "Bío-Bío",
        "La Araucanía",
        "Los Ríos",
        "Los Lagos",
        "Aysén",
        "Magallanes",
      ],
    },
  ];
  stateList1: any = [];
  stateList2: any = [];
  stateList3: any = [];
  rango: any = [
    {
      name: "C$ 5,000 - C$ 10,000",
    },
    {
      name: "C$ 10,001 - C$ 15,000",
    },
    {
      name: "C$ 15,001 - C$ 20,000",
    },
    {
      name: "C$ 20,001 - C$ 25,000",
    },
    {
      name: "C$ 25,001 - C$ 30,000",
    },
    {
      name: "C$ 35,000 a Más",
    },
  ];
  school: any = [
    {
      name: "Público",
    },
    {
      name: "Privado",
    },
  ];

  selectedIdentity: string;
  studentModel: {
    name: string;
    lastname: string;
    birthday: Date;
    gen: string;
    civil_state: string;
    nacionality_student: string;
    age: number;
    doc_type: string;
    doc_value: string;
    email: string;
    telHome: string;
    telCellular: string;
    isWA: boolean;
    country: string;
    country_state: string;
    city: string;
    address: string;
    school_name: string;
    school_type: string;
    school_country: string;
    school_state: string;
    school_city: string;
    school_address: string;
    workplace: string;
    occupation: string;
    rank: string;
    urlDiploma: string;
    urlCertificate: string;
    urlCard1: string;
    urlCard2: string;
    urlPhoto: string;
    carrera: string;
    campus: string;
    turn: string;
    done: boolean;
    createDate: Date;
    lastModifieldDate: Date;
    referenceNumber: string;
    stateChange: number;
    rejectnote: string;
    paystate: boolean;
    docstate: boolean;
    contactstate: boolean;
    log: string;
  };
  @ViewChild("form-step1", { static: true }) form1: ElementRef;

  isCloseMessage = false;
  constructor(
    private _builder: FormBuilder,
    public studentService: StudentService,
    private storage: AngularFireStorage,
    public configService: ConfigService,
    private http: HttpClient,
    private viewPortscroller: ViewportScroller,
    private mailService: MailService
  ) {
    this.payDetail = 1;

    this.welcomeValidation = this._builder.group({
      campus: ["", Validators.required],
      career: ["", Validators.required],
      turn: ["", Validators.required],
    });
    this.stepValidation1 = this._builder.group({
      name: ["", [Validators.required, Validators.minLength(4)]],
      lastname: ["", Validators.required],
      birthday: ["", Validators.required],
      gender: ["", Validators.required],
      civil_status: ["", Validators.required],
      nationality: ["", Validators.required],
      doc: ["", Validators.required],
      docValue: ["", Validators.required],
    });

    this.stepValidation2 = this._builder.group({
      email: [
        "",
        [
          Validators.required,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
        ],
      ],
      telHome: [""],
      cellular: ["", Validators.required],
      countryForm1: ["", Validators.required],
      wa: [""],
      stateForm1: ["", Validators.required],
      cityForm1: ["", Validators.required],
      addressForm1: ["", Validators.required],
    });
    this.stepValidation3 = this._builder.group({
      occupation: [""],
      rank: ["", Validators.required],
      school_name: ["", Validators.required],
      school_type: ["", Validators.required],
      school_country: ["", Validators.required],
      school_state: ["", Validators.required],
      school_city: ["", Validators.required],
      school_address: ["", Validators.required],

      file1: [""],
      file2: ["", Validators.required],
      file3: ["", Validators.required],
      file4: ["", Validators.required],
      file5: ["", Validators.required],
      workplace: [""],
    });

    this.careerObjects = [
      {
        name: "Medicina y Cirugía",
        code: "MD",
        reg: true,
        sab: false,
        dom: false,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Medicina Veterinaria",
        code: "VE",
        reg: true,
        sab: true,
        dom: false,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Enfermería",
        code: "EF",
        reg: true,
        sab: false,
        dom: false,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Farmacia",
        code: "FA",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Psicología",
        code: "PS",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Administración de Empresas",
        code: "AD",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Contabilidad Pública y Auditoría",
        code: "CT",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Administración Turismo y Hotelería",
        code: "TU",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Mercadotecnia",
        code: "MC",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Derecho",
        code: "DE",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: true,
      },
      {
        name: "Relaciones Internacionales y Comercio Exterior",
        code: "RI",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
      {
        name: "Ingeniería en Sistemas",
        code: "IS",
        reg: true,
        sab: true,
        dom: true,
        central: true,
        doral: true,
        jinotepe: true,
        esteli: false,
      },
    ];
    this.isRegular = false;
    this.isSabbatine = false;
    this.isDominical = false;
  }
  @HostListener("document:mousemove", ["$event"])
  onMouseMove(e) {
    this.mouseX = e.pageX;
    this.mouseY = e.pageY;
    this.transX = (14 * this.mouseX) / 600 + 50;
    this.transY = (14 * this.mouseY) / 600 + 50;
    // const tipe = document.getElementsByClassName('.text');
  }
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.innerHeight = event.target.innerHeight + 87;
  }
  ngOnInit(): void {
    this.http.get("./assets/otrosPaises.json").pipe(
      map((res) => {
        this.country = res;
        return res;
      })
    );
    this.wh = window.outerWidth;
    this.ww = window.outerHeight;
  }

  public createStudent(student: Student) {
    this.studentService.saveStudent(student);
  }

  get primaryEmail() {
    return this.stepValidation2.get("email");
  }
  get primaryBirthday() {
    return this.stepValidation1.get("birthday");
  }
  saveStudent() {
    this.getRandomCode();
    var refNumber = this.randomNumer;
    //pantalla de bienvenida
    var turno = this.welcomeValidation.get("turn").value;
    var Name = this.stepValidation1.get("name").value;
    var Lastname = this.stepValidation1.get("lastname").value;
    var Birthday = this.stepValidation1.get("birthday").value;
    var Gender = this.stepValidation1.get("gender").value;
    var civilStatus = this.stepValidation1.get("civil_status").value;
    var Nationality = this.stepValidation1.get("nationality").value;
    var docType = this.stepValidation1.get("doc").value;
    var docVal = this.stepValidation1.get("docValue").value;
    var timeDiff = Math.abs(Date.now() - new Date(Birthday).getTime());
    let Age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    //formulario 2
    var Email = this.stepValidation2.get("email").value;
    var TelHome = this.stepValidation2.get("telHome").value;
    var Cellular = this.stepValidation2.get("cellular").value;
    var WA = this.stepValidation2.get("wa").value;
    var Country = this.stepValidation2.get("countryForm1").value;
    var Country_State = this.stepValidation2.get("stateForm1").value;
    var City = this.stepValidation2.get("cityForm1").value;
    var Address = this.stepValidation2.get("addressForm1").value;
    //formulario 3
    var schoolName = this.stepValidation3.get("school_name").value;
    var schoolType = this.stepValidation3.get("school_type").value;
    var schoolCountry = this.stepValidation3.get("school_country").value;
    var schoolState = this.stepValidation3.get("school_state").value;
    var schoolCity = this.stepValidation3.get("school_city").value;
    var schoolAddress = this.stepValidation3.get("school_address").value;
    var Workplace = this.stepValidation3.get("workplace").value;
    var Occupation = this.stepValidation3.get("occupation").value;
    var Rank = this.stepValidation3.get("rank").value;
    this.studentModel = {
      name: Name,
      lastname: Lastname,
      birthday: Birthday,
      gen: Gender,
      civil_state: civilStatus,
      nacionality_student: Nationality,
      age: Age,
      doc_type: docType,
      doc_value: docVal,
      email: Email,
      telHome: TelHome,
      telCellular: Cellular,
      isWA: WA,
      country: Country,
      country_state: Country_State,
      city: City,
      address: Address,
      school_name: schoolName,
      school_type: schoolType,
      school_country: schoolCountry,
      school_state: schoolState,
      school_city: schoolCity,
      school_address: schoolAddress,
      workplace: Workplace,
      occupation: Occupation,
      urlDiploma: this.imgDiploma,
      urlCertificate: this.imgCertificate,
      urlCard1: this.imgIdentiCard1,
      urlCard2: this.imgIdentiCard2,
      urlPhoto: this.imgPhoto,
      carrera: this.careerSelected.name,
      campus: this.campusSelected,
      turn: turno,
      rank: Rank,
      done: true,
      createDate: new Date(),
      lastModifieldDate: new Date(),
      referenceNumber: refNumber,
      stateChange: 0,
      rejectnote: "",
      paystate: false,
      docstate: false,
      contactstate: false,
      log: "",
    };
    this.createStudent(this.studentModel);
    this.configService.currentStep = 6;
    this.sendConfirmationEmail();
  }
  radioGenChangeHandler(event: any) {
    this.gen = event.target.value;
  }
  radioCivilChangeHandler(event: any) {
    this.civil_status = event.target.value;
  }
  radioCampusChange(event: any) {
    this.campusSelected = event.target.value;
    this.campusSelectedList = [];
    if (event.target.value == "central") {
      for (let index = 0; index < this.careerObjects.length; index++) {
        if (this.careerObjects[index].central) {
          this.campusSelectedList.push(this.careerObjects[index]);
        }
      }
    } else if (event.target.value == "doral") {
      for (let index = 0; index < this.careerObjects.length; index++) {
        if (this.careerObjects[index].doral) {
          this.campusSelectedList.push(this.careerObjects[index]);
        }
      }
    } else if (event.target.value == "jinotepe") {
      for (let index = 0; index < this.careerObjects.length; index++) {
        if (this.careerObjects[index].jinotepe) {
          this.campusSelectedList.push(this.careerObjects[index]);
        }
      }
    } else if (event.target.value == "esteli") {
      for (let index = 0; index < this.careerObjects.length; index++) {
        if (this.careerObjects[index].esteli) {
          this.campusSelectedList.push(this.careerObjects[index]);
        }
      }
    }
  }
  getSelectedIdentity(e) {
    this.docType = this.stepValidation1.get("doc").value;
    if (this.docType === "Cédula") {
      this.isCedula = true;
    }
  }
  getSelectedCountry(e) {
    let country = this.stepValidation2.get("countryForm1").value;
    this.countryList.forEach((element) => {
      if (element.name === country) {
        this.stateList1 = element.state;
      }
    });
  }
  getSelectedSchoolCountry(e) {
    let country = this.stepValidation3.get("school_country").value;
    this.countryList.forEach((element) => {
      if (element.name === country) {
        this.stateList2 = element.state;
      }
    });
  }

  getSelectedCareer(e) {
    this.careerSelected = e;
    this.configService.career = e;
    this.isRegular = this.careerSelected.reg;
    this.isSabbatine = this.careerSelected.sab;
    this.isDominical = this.careerSelected.dom;
  }
  getSelectedBirth(e) {
    let birthdate = e.target.value;
    if (birthdate) {
      var timeDiff = Math.abs(Date.now() - new Date(birthdate).getTime());
      this.Age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    }
  }

  checkDocType(doc: string) {
    var splitted = doc.split("-", 3);
  }

  openDiploma(e) {
    this.urlDiploma = e.target.files[0];
    this.urlDiplomaName = e.target.files[0].name;
  }
  openCertificate(e) {
    this.urlCertificate = e.target.files[0];
    this.urlCertificateName = e.target.files[0].name;
  }
  openIndetiCard1(e) {
    this.urlIdentiCard1 = e.target.files[0];
    this.urlIdentiCard1Name = e.target.files[0].name;
  }
  openIndetiCard2(e) {
    this.urlIdentiCard2 = e.target.files[0];
    this.urlIdentiCard2Name = e.target.files[0].name;
  }
  openPhoto(e) {
    this.urlPhoto = e.target.files[0];
    this.urlPhotoName = e.target.files[0].name;
  }
  upLoadDiploma() {
    if (this.urlDiploma.length != 0 || this.urlDiplomaName.length != 0) {
      const id = Math.random().toString(36).substring(2);
      const filePath = `uploads/doc_${id}${this.urlDiplomaName}`;
      const ref = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, this.urlDiploma);
      this.uploadPercent = task.percentageChanges();
      this.stateDocument = "Cargando diploma ";
      task
        .snapshotChanges()
        .pipe(
          finalize(() => {
            this.urlImage = ref.getDownloadURL();
            this.urlImage.subscribe((url) => {
              if (url) {
                this.imgDiploma = url;
                this.upLoadCertificate();
              }
            });
          })
        )
        .subscribe();
    } else {
      this.upLoadCertificate();
    }
  }
  upLoadCertificate() {
    const id = Math.random().toString(36).substring(2);
    const filePath = `uploads/doc_${id}${this.urlCertificateName}`;
    const ref = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, this.urlCertificate);
    this.uploadPercent = task.percentageChanges();
    this.stateDocument = "Cargando certificado de notas ";
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.urlImage = ref.getDownloadURL();
          this.urlImage.subscribe((url) => {
            if (url) {
              this.imgCertificate = url;
              this.upLoadIdCard1();
            }
          });
        })
      )
      .subscribe();
  }
  upLoadIdCard1() {
    const id = Math.random().toString(36).substring(2);
    const filePath = `uploads/doc_${id}${this.urlIdentiCard1Name}`;
    const ref = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, this.urlIdentiCard1);
    this.uploadPercent = task.percentageChanges();
    this.stateDocument = "Cargando cédula ";
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.urlImage = ref.getDownloadURL();
          this.urlImage.subscribe((url) => {
            if (url) {
              this.imgIdentiCard1 = url;
              this.upLoadIdCard2();
            }
          });
        })
      )
      .subscribe();
  }
  upLoadIdCard2() {
    const id = Math.random().toString(36).substring(2);
    const filePath = `uploads/doc_${id}${this.urlIdentiCard2Name}`;
    const ref = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, this.urlIdentiCard2);
    this.uploadPercent = task.percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.urlImage = ref.getDownloadURL();
          this.urlImage.subscribe((url) => {
            if (url) {
              this.imgIdentiCard2 = url;
              this.upLoadPhoto();
            }
          });
        })
      )
      .subscribe();
  }
  upLoadPhoto() {
    const id = Math.random().toString(36).substring(2);
    const filePath = `uploads/doc_${id}${this.urlPhotoName}`;
    const ref = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, this.urlPhoto);
    this.uploadPercent = task.percentageChanges();
    this.stateDocument = "Cargando fotografía ";
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          this.urlImage = ref.getDownloadURL();
          this.urlImage.subscribe((url) => {
            if (url) {
              this.imgPhoto = url;
              this.saveStudent();
            }
          });
        })
      )
      .subscribe();
  }
  endStep() {
    this.upLoadDiploma();
    this.configService.currentStep = 5;
  }
  goToStep3() {
    this.allForm.nativeElement.scrollTop = 0;
    this.configService.currentLetter = "N";
    this.configService.currentStep = 4;
    this.configService.isCompletedStep2 = true;
  }
  goToStep2() {
    this.allForm.nativeElement.scrollTop = 0;
    this.configService.currentLetter = "C";
    this.configService.currentStep = 3;
    this.configService.isCompletedStep1 = true;
  }
  goToStep1() {
    this.allForm.nativeElement.scrollTop = 0;
    this.configService.currentLetter = "U";
    this.configService.currentStep = 2;
    this.configService.isCompletedWelcome = true;
  }
  backToWelcome(){
    this.configService.currentStep = 1
  }
  backToStep1() {
    this.configService.currentLetter = "U";
    this.configService.currentStep = 2;
  }
  backToStep2() {
    this.allForm.nativeElement.scrollTop = 0;
    this.configService.currentLetter = "C";
    this.configService.currentStep = 3;
  }

  reloadPage(){
    window.location.reload()
  }

  onClickScroll(elementId: string): void {
    this.viewPortscroller.scrollToAnchor(elementId);
  }

  public getJSON(): Observable<any> {
    return this.http.get("src/app/utils/otrosPaises.json");
  }
  get name() {
    return this.stepValidation1.get("name");
  }

  getRandomCode() {
    this.randomNumer = this.careerSelected.code;
    for (let index = 0; index < 5; index++) {
      var number = Math.floor(Math.random() * (9 - 0)) + 0;
      this.randomNumer += number;
    }
  }
  private minimumAge(age: number): ValidatorFn {
    return (fg: FormGroup): ValidationErrors => {
      let result: ValidationErrors = null;
      if (fg.get("birthday").valid) {
        // carefull, moment months range is from 0 to 11
        const value: { year: string; month: string; day: string } = fg.value;
        const date = moment({
          year: +value.year,
          month: +value.month - 1,
          day: +value.day,
        }).startOf("day");
        if (date.isValid()) {
          // https://momentjs.com/docs/#/displaying/difference/
          const now = moment().startOf("day");
          const yearsDiff = date.diff(now, "years");
          if (yearsDiff > -age) {
            result = {
              minimumAge: {
                requiredAge: age,
                actualAge: yearsDiff,
              },
            };
          }
        }
      }
      return result;
    };
  }

  async sendConfirmationEmail(): Promise<void> {
    try {
      const formData = this.constructFormData();
      const mailSent = await this.sendEmail(formData);
      if (mailSent === "Message sent!") {
       
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  formatFullName(texto: string) {
    var finalText = texto.split(" ");
    if (finalText.length > 2) {
      return finalText[0] + " " + finalText[2];
    } else {
      return finalText[0] + " " + finalText[1];
    }
  }

  constructFormData(): FormData {
    const formData: FormData = new FormData();
    formData.append(
      "fullName",
      this.formatFullName(
        `${this.studentModel.name} ${this.studentModel.lastname}`
      )
    );
    formData.append("campusName", this.studentModel.campus);
    formData.append("email", this.studentModel.email);
    return formData;
  }

  async sendEmail(formData: FormData): Promise<string> {
    try {
      const res = await this.mailService.onSendService(formData).toPromise();
      return res.message || ""; // Assuming 'message' contains the status of the sent email
    } catch (error) {
      console.error("Error sending email:", error);
      throw new Error("Error sending the email.");
    }
  }

  closeMessage(){
    this.isCloseMessage = true
  }
}
